<template>
    <bee-label v-if="readonly" :bold="true" :content="localValue" color="primary"  :emptyState="emptyState" />
    <v-text-field
        v-else
        color="primary"
        :label="insideTable? '' : label"
        v-model="localValue"
        :hide-details="(!!hideDetails) ? 'hide' : false"
        :outlined="!insideTable"
        :dense="!insideTable"
        :rules="rules"
        :disabled="(readonly && !insideTable) || disabledValue"
        :readonly="readonly"
        style="width: 100%"
        :solo="readonly && insideTable"
        @change="$emit('change', localValue)"
        @keydown.enter.prevent="$emit('keydown-enter-prevent')"
        @keydown.esc.prevent="$emit('keydown-esc-prevent')"
        @keydown.ctrl.down="$emit('keydown-ctrl-down')"
        @keydown.tab="$emit('keydown-tab')"
        @input="$emit('input', $event)"
        @blur="$emit('blur')"
        @click:append="$emit('click-append')"
        ref="BeeTextField"
        :type="type"
        :autofocus="autofocus"
        :append-icon="appendIcon"
        :prefix="prefix"
    ></v-text-field>
</template>

<script>
import ls from '../../../../settings/localStorageExtension'
import baseBeeComponent from "../../baseBeeComponent";

const match = /\D{1,3}(,\D{3})*(\.\D+)?$/g // Discard commas and decimal point

export default {
    name: "BeeTextField",
    
    mixins: [baseBeeComponent],

    props: [
        "rules",
        "label",
        "value",
        "readonly",
        "insideTable",
        "emptyState",
        "disabled",
        "autofocus",
        "type",
        "appendIcon",
        "hideDetails",
        "showOnlyNumbersPatch",
        "prefix"
    ],

    computed:{
        localValue: {
            get: function() {
                return this.value
                    ? !ls.getVisibleSymbolMoney() &&
                    this.showOnlyNumbersPatch &&
                    this.hasNumber(this.value) 
                        ? this.value.toString().replace(match, "")
                        : this.value
                    : this.value
            },
            set: function(value) {
                this.$emit('input', value)
            }
        }
    },
    
    methods:{
        hasNumber(myString) {
            return /\d/.test(myString); }
    }
}
</script>
<style >
.v-text-field__details {
    display: flex !important;
}

.v-text-field {
    padding-top: 0px !important;
    margin-top: 4px 0px !important;
}
</style>